import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Button, Flex } from '@ubisend/pulse-components';

import { useDelivery, useTheme } from '../../../../../hooks';
import { useNotificationReducer } from '../../../../../reducers';

const LocationComposer = () => {
  const theme = useTheme();

  const notification = useNotificationReducer();

  const { t } = useTranslation('bots');

  const { sendLocationMessage } = useDelivery();

  const [isSending, setIsSending] = useState(false);

  const handleSendLocation = () => {
    if (!navigator.geolocation) {
      notification.dispatch({
        type: notification.TYPES.SHOW_ERROR,
        message: t('send_location_error_message')
      });
      return;
    }

    setIsSending(true);
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        sendLocationMessage(null, latitude, longitude);
        setIsSending(false);
      },
      () => {
        notification.dispatch({
          type: notification.TYPES.SHOW_ERROR,
          message: t('send_location_error_message')
        });
        setIsSending(false);
      }
    );
  };

  return (
    <Flex background="white" pad column>
      <Button
        variant="secondary"
        custom_colour={theme.sentMessage.background}
        autoHeight
        fat
        middle
        rounded
        smallText
        onClick={handleSendLocation}
        disabled={isSending}
      >
        <Flex padSm xSpace>
          <Flex center>📍 {t('send_location_label')}</Flex>
        </Flex>
      </Button>
    </Flex>
  );
};

export default LocationComposer;
